import { ElementType, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children: ReactNode;
  className?: string;
  component?: ElementType;
  id?: string;
};

export const Panel = ({
  children,
  className = "",
  component = "article",
  id,
}: Props) => {
  const Element = component;
  return (
    <Element
      id={id}
      className={twMerge(
        "rounded-2xl border border-neutral-500 bg-white pb-2 pl-2 pr-2 pt-2 laptop:pb-3 laptop:pl-3 laptop:pr-3 laptop:pt-3",
        className,
      )}
    >
      {children}
    </Element>
  );
};
